import { ReactNode } from "react";
import logoPoolTonight from "../../assets/logo-pooltonight.png";
import "./LoadingMask.scss";

interface LoadingMaskProps {
  children?: ReactNode;
  message?: string;
}

const LoadingMask: React.FC<LoadingMaskProps> = ({ children, message }) => {
  return (
    <div className="loading-mask">
      <div className="loading-mask-content">
        <img src={logoPoolTonight} alt="Pool Tonight Logo" />
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default LoadingMask;
